(() => {
  if (window.horusBondsBooted) return;
  window.horusBondsBooted = true;
  const read = (root, selector) => JSON.parse(root.querySelector(selector)?.textContent || '{}');
  const formatter = root => {
    const example = root.dataset.moneyExample || '';
    if (example.includes('1,00')) {
      const [prefix,suffix] = example.split('1,00');
      const decimal = new Intl.NumberFormat('de-DE',{minimumFractionDigits:2,maximumFractionDigits:2});
      return {format:value=>prefix+decimal.format(value)+(suffix || '')};
    }
    return new Intl.NumberFormat(root.dataset.locale || 'en',{style:'currency',currency:root.dataset.currency || 'EUR'});
  };
  const initProduct = root => {
    if (root.dataset.bondsReady) return;
    root.dataset.bondsReady = 'true';
    const variants = read(root,'[data-bonds-variants]');
    const strings = read(root,'[data-bonds-strings]');
    const media = read(root,'[data-bonds-media]');
    const form = root.querySelector('.hb-product-form');
    const button = root.querySelector('[data-bonds-add]');
    const message = root.querySelector('[data-bonds-message]');
    const money = formatter(root);
    const slides = [...root.querySelectorAll('[data-gallery-slide]')];
    const thumbs = [...root.querySelectorAll('[data-gallery-thumb]')];
    let active = 0;
    const show = index => {
      active = (index + slides.length) % slides.length;
      slides.forEach((slide,i) => {slide.hidden=i!==active; if(i!==active)slide.querySelector('video')?.pause();});
      thumbs.forEach((thumb,i)=>{thumb.classList.toggle('is-active',i===active);thumb.setAttribute('aria-pressed',String(i===active));});
      root.querySelector('[data-gallery-count]').textContent = `${active+1} / ${slides.length}`;
    };
    thumbs.forEach((thumb,i)=>thumb.addEventListener('click',()=>show(i)));
    root.querySelector('[data-gallery-prev]')?.addEventListener('click',()=>show(active-1));
    root.querySelector('[data-gallery-next]')?.addEventListener('click',()=>show(active+1));
    const gallery = root.querySelector('[data-bonds-gallery]');
    let touchX = 0;
    gallery.addEventListener('touchstart',event=>{touchX=event.changedTouches[0].clientX;},{passive:true});
    gallery.addEventListener('touchend',event=>{const distance=event.changedTouches[0].clientX-touchX;if(Math.abs(distance)>55)show(active+(distance<0?1:-1));},{passive:true});
    root.querySelector('[data-motion-toggle]')?.addEventListener('click',event=>{
      const toggle=event.currentTarget;
      const image=root.querySelector('[data-motion-image]');
      const playing=toggle.getAttribute('aria-pressed')!=='true';
      image.src=playing?image.dataset.motionUrl:image.dataset.motionPoster;
      toggle.setAttribute('aria-pressed',String(playing));
      toggle.textContent=playing?toggle.dataset.pauseLabel:'▶ '+toggle.dataset.playLabel;
    });
    const packMode = root.dataset.pack === 'true';
    const units = [...root.querySelectorAll('[data-pack-unit]')];
    const options = [...root.querySelectorAll('[data-bonds-option]')];
    const variantFor = inputs => variants.find(variant => inputs.length === 0 || inputs.every(input => input.value && variant.options[Number(input.dataset.packOption ?? input.dataset.bondsOption)] === input.value));
    const packQty = () => Number(form.querySelector('[name="bonds_pack"]:checked')?.value || 1);
    const rateFor = () => .5;
    const selectedUnits = () => units.slice(0,packQty());
    const unitVariant = unit => variantFor([...unit.querySelectorAll('[data-pack-option]')]);
    const imageFor = finish => media.find(image => (image.alt || '').toLowerCase().includes(finish.toLowerCase()));
    const syncFinish = (scope,selector,swatchSelector) => {
      scope.querySelectorAll(swatchSelector).forEach(swatch=>{
        const value=swatch.dataset.packSwatch || swatch.dataset.bondsSwatch;
        const input=scope.querySelector(`${selector}[data-${packMode?'pack':'bonds'}-option="${swatch.dataset.optionIndex}"]`);
        const selected=input?.value===value;
        swatch.classList.toggle('is-active',selected);
        swatch.setAttribute('aria-pressed',String(selected));
        if(selected){
          scope.querySelector('[data-finish-label]').textContent=value;
          const image=imageFor(value);
          const preview=scope.querySelector('.hb-unit-preview img');
          if(image && preview){preview.src=image.url;preview.removeAttribute('srcset');preview.alt=image.alt;}
        }
      });
    };
    const showFinish = finish => {
      const image=imageFor(finish);
      const index=image ? slides.findIndex(slide=>slide.dataset.mediaId===String(image.id)) : -1;
      if(index>=0)show(index);
    };
    const update = () => {
      message.textContent = '';
      if(packMode){
        const quantity=packQty();
        const selected=selectedUnits();
        const ready=selected.filter(unit=>unitVariant(unit)?.available).length;
        const subtotal=selected.reduce((sum,unit)=>sum+(unitVariant(unit)?.price || variants[0].price),0);
        const rate=rateFor(quantity);
        const total=Math.round(subtotal*(1-rate));
        units.forEach((unit,i)=>{unit.hidden=i>=quantity;unit.querySelectorAll('select,input').forEach(input=>{input.disabled=i>=quantity;if(input.tagName==='SELECT')input.required=i<quantity;});unit.classList.toggle('is-ready',!!unitVariant(unit)?.available);syncFinish(unit,'[data-pack-option]','[data-pack-swatch]');});
        root.querySelectorAll('[data-pack-card]').forEach(card=>card.classList.toggle('is-selected',card.querySelector('input').checked));
        root.querySelector('[data-pack-progress]').textContent=`${ready}/${quantity} ${strings.ready}`;
        root.querySelector('[data-pack-selected-count]').textContent=quantity;
        root.querySelector('[data-pack-subtotal]').textContent=rate?money.format(subtotal/100):'';
        root.querySelector('[data-pack-selection-total]').textContent=money.format(total/100);
        root.querySelector('[data-pack-saving]').textContent=rate?`${strings.save} ${money.format((subtotal-total)/100)}`:'';
        button.disabled=ready!==quantity;
        button.textContent=ready===quantity?`${strings.add} · ${money.format(total/100)}`:strings.choose;
      }else{
        const variant=variantFor(options);
        const incomplete=options.some(option=>!option.value);
        button.disabled=incomplete || !variant?.available;
        button.textContent=incomplete?strings.choose:variant?.available?strings.add:strings.unavailable;
        syncFinish(form,'[data-bonds-option]','[data-bonds-swatch]');
        if(variant){
          form.querySelector('[data-bonds-variant]').value=variant.id;
          root.querySelector('[data-bonds-price]').textContent=money.format(variant.price/100);
          const url=new URL(window.location.href);url.searchParams.set('variant',variant.id);history.replaceState({},'',url);
        }
      }
    };
    form.querySelectorAll('select,input[type="radio"]').forEach(input=>input.addEventListener('change',update));
    root.querySelectorAll('[data-bonds-swatch]').forEach(swatch=>swatch.addEventListener('click',()=>{options[Number(swatch.dataset.optionIndex)].value=swatch.dataset.bondsSwatch;showFinish(swatch.dataset.bondsSwatch);update();}));
    root.querySelectorAll('[data-pack-swatch]').forEach(swatch=>swatch.addEventListener('click',()=>{const unit=swatch.closest('[data-pack-unit]');unit.querySelector(`[data-pack-option="${swatch.dataset.optionIndex}"]`).value=swatch.dataset.packSwatch;showFinish(swatch.dataset.packSwatch);update();}));
    form.addEventListener('submit',async event=>{
      event.preventDefault();
      if(!form.reportValidity() || button.disabled)return;
      button.disabled=true;button.textContent=strings.adding;
      try{
        let body;
        let headers={'Accept':'application/json'};
        if(packMode){
          const grouped=new Map();
          selectedUnits().forEach(unit=>{const id=unitVariant(unit).id;grouped.set(id,(grouped.get(id)||0)+1);});
          body=JSON.stringify({items:[...grouped].map(([id,quantity])=>({id,quantity,properties:{'_horus_bonds':'bracelet-set'}}))});
          headers['Content-Type']='application/json';
        }else body=new FormData(form);
        const response=await fetch(root.dataset.addUrl,{method:'POST',headers,body});
        const result=await response.json();
        if(!response.ok)throw new Error(result.description||strings.error);
        window.location.assign(root.dataset.cartUrl);
      }catch(error){update();message.textContent=error.message||strings.error;}
    });
    update();
  };
  const initCollection = root => {
    if (root.dataset.bondsReady) return;
    root.dataset.bondsReady = 'true';
    const filters = [...root.querySelectorAll('[data-bonds-filter]')];
    filters.forEach(button => button.addEventListener('click',() => {
      filters.forEach(filter => {filter.classList.toggle('is-active',filter===button);filter.setAttribute('aria-pressed',String(filter===button));});
      root.querySelectorAll('[data-bonds-category]').forEach(card => {card.hidden = button.dataset.bondsFilter !== 'all' && card.dataset.bondsCategory !== button.dataset.bondsFilter;});
    }));
  };
  const initBuilder = root => {
    if (root.dataset.bondsReady) return;
    root.dataset.bondsReady = 'true';
    const catalog = read(root,'[data-bonds-catalog]');
    const strings = read(root,'[data-bonds-strings]');
    const cards = [...root.querySelectorAll('[data-bonds-set-card]')];
    const money = formatter(root);
    const button = root.querySelector('[data-bonds-set-add]');
    const message = root.querySelector('[data-bonds-set-message]');
    const getProduct = card => catalog.find(product => String(product.id)===card.querySelector('[data-bonds-set-product]').value);
    const getVariant = card => getProduct(card)?.variants.find(variant=>String(variant.id)===card.querySelector('[data-bonds-set-variant]').value);
    const included = () => cards.filter(card => card.querySelector('[data-bonds-include]').checked);
    const update = () => {
      const selected = included();
      const count = selected.length;
      const subtotal = selected.reduce((sum,card)=>sum+(getVariant(card)?.price || getProduct(card)?.variants[0]?.price || 0),0);
      const rate = count>=4 ? .2 : count>=3 ? .15 : count>=2 ? .1 : 0;
      const total = Math.round(subtotal*(1-rate));
      root.querySelector('[data-bonds-set-count]').textContent = `${count} ${strings.pieces}`;
      root.querySelector('[data-builder-meter]').style.width = `${Math.min(count,4)*25}%`;
      root.querySelectorAll('[data-builder-tier]').forEach(tier=>tier.classList.toggle('is-unlocked',count>=Number(tier.dataset.builderTier)));
      root.querySelector('[data-builder-progress]').setAttribute('aria-valuenow',String(count));
      root.querySelector('[data-bonds-set-original]').textContent = rate ? money.format(subtotal/100) : '';
      root.querySelector('[data-bonds-set-total]').textContent = money.format(total/100);
      root.querySelector('[data-bonds-set-saving]').textContent = rate ? `${strings.save} ${money.format((subtotal-total)/100)}` : '';
      root.querySelector('[data-bonds-set-saving]').hidden = !rate;
      button.disabled = count===0;
      cards.forEach(card=>{card.classList.toggle('is-excluded',!card.querySelector('[data-bonds-include]').checked);card.querySelector('[data-bonds-set-unit]').textContent=money.format((getVariant(card)?.price || getProduct(card)?.variants[0]?.price || 0)/100);});
      message.textContent = '';
    };
    const populate = card => {
      const product = getProduct(card);
      const select = card.querySelector('[data-bonds-set-variant]');
      const needsChoice = product.variants.length>2 || product.variants.some(variant=>variant.options.some(value=>/^[A-Z]$/.test(value)));
      select.replaceChildren();
      if (needsChoice) select.add(new Option(strings.choose,''));
      product.variants.forEach(variant=>{const option=new Option(variant.title,String(variant.id));option.disabled=!variant.available;select.add(option);});
      const image=card.querySelector('img');
      image.src=product.image;image.removeAttribute('srcset');image.alt=product.title;
      update();
    };
    cards.forEach(card=>{
      card.querySelector('[data-bonds-set-product]').addEventListener('change',()=>populate(card));
      card.querySelector('[data-bonds-set-variant]').addEventListener('change',update);
      card.querySelector('[data-bonds-include]').addEventListener('change',update);
      populate(card);
    });
    root.querySelector('.hb-set-form').addEventListener('submit',async event=>{
      event.preventDefault();
      const selected=included();
      if (!selected.length || selected.some(card=>!getVariant(card)?.available)) {message.textContent=strings.incomplete; selected.find(card=>!getVariant(card))?.querySelector('[data-bonds-set-variant]').focus();return;}
      const items=selected.map(card=>({id:getVariant(card).id,quantity:1,properties:{'_horus_bonds':'mix-and-match'}}));
      button.disabled=true;button.textContent=strings.adding;
      try {
        const response=await fetch(root.dataset.addUrl,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items})});
        const result=await response.json();
        if(!response.ok)throw new Error(result.description||strings.error);
        window.location.assign(root.dataset.cartUrl);
      }catch(error){message.textContent=error.message||strings.error;button.disabled=false;button.textContent=strings.add;}
    });
    update();
  };
  const init = () => {document.querySelectorAll('[data-bonds-product]').forEach(initProduct);document.querySelectorAll('[data-bonds-collection]').forEach(initCollection);document.querySelectorAll('[data-bonds-builder]').forEach(initBuilder);};
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
  document.addEventListener('shopify:section:load',init);
})();
